// Month indices are zero-based (January = 0, June = 5) to match the Date constructor.
const SEMESTER_RESET_DATES = [
  { month: 0, day: 15 },
  { month: 5, day: 15 },
];

export const mostRecentSemesterDate = (now: Date = new Date()): Date => {
  const year = now.getFullYear();
  // Include prior-year candidates so there is always at least one date on or before `now`,
  // e.g. in early January before the Jan 15 boundary has been reached.
  const candidates = [
    ...SEMESTER_RESET_DATES.map(({ month, day }) => new Date(year, month, day)),
    ...SEMESTER_RESET_DATES.map(({ month, day }) => new Date(year - 1, month, day)),
  ];
  const past = candidates.filter(date => date <= now);
  if (past.length === 0) {
    return new Date(0);
  }
  return past.reduce((a, b) => (a > b ? a : b));
};

export const isResetDue = (user: Pick<Users.User, 'createdAt' | 'lastResetDate'> | undefined): boolean => {
  if (!user?.createdAt) {
    return false;
  }
  const reference = user.lastResetDate ?? user.createdAt;
  return reference < mostRecentSemesterDate();
};
